export function init($name = '') {
    let elem = $($name);

    if (!elem.length) {
        return;
    }

    elem.click(function(e){
        e.preventDefault();

       $('html,body').animate({scrollTop: $(this).parents('.section').next().offset().top - 50}, 600);
    });
}